import { jsx as a, Fragment as S, jsxs as W } from "react/jsx-runtime";
import { forwardRef as G, Fragment as _, createElement as O } from "react";
import q from "./styles.module.less.js";
import { QuestionTabList as V } from "./tab-list/index.js";
import { TextareaInput as z } from "../textarea-input/index.js";
import { YesNoInput as J } from "../yes-no-input/index.js";
import { NumericInput as U } from "../numeric-input/index.js";
import { CheckboxInput as X } from "../checkbox-input/index.js";
import { DateInput as Z } from "../date-input/index.js";
import { DateTimeInput as ee } from "../date-time-input/index.js";
import { InputDescription as A } from "../input-description/index.js";
import { InputLabel as re } from "../input-label/index.js";
import { RadioInputGroup as ae, RadioInput as ne } from "../radio-input/index.js";
import { TimeInput as te } from "../time-input/index.js";
import { QuestionType as l } from "@law-connect/types";
import { ScaleInput as se } from "../scale-input/index.js";
import { SplitDateInput as oe } from "../split-date-input/index.js";
import { FileInput as le } from "../file-input/index.js";
import { EmailInput as ie } from "../email-input/index.js";
import ue from "../text-input/index.js";
import { PhoneInput as pe } from "../phone-input/index.js";
import { SelectInput as ce } from "../select-input/index.js";
import { QuestionTooltip as me } from "../question-tooltip/index.js";
import { DropdownInput as fe } from "../dropdown-input/index.js";
import { InputError as de } from "../input-error/index.js";
const L = (w, k) => {
  for (const o of k) {
    if (o.id === w)
      return o;
    if (o.type === l.MultiPart) {
      const e = L(w, o.questions);
      if (e)
        return e;
    }
  }
  return null;
}, v = (w, k) => {
  var s;
  const o = /{{(.*?)(?:, *(.*?))?}}/g;
  let e, u = w;
  for (; e = o.exec(w); ) {
    const b = e[1].trim().split("."), P = b[0], d = (s = e[2]) == null ? void 0 : s.trim(), g = L(P, k);
    if (g && g.answer)
      if (typeof g.answer == "object") {
        const r = g.answer;
        b.length > 1 ? u = u.replace(
          e[0],
          r[b[1]] || d || ""
        ) : u = u.replace(e[0], g.answer);
      } else
        u = u.replace(e[0], g.answer);
    else d ? u = u.replace(e[0], d) : u = u.replace(e[0], "");
  }
  return u;
}, F = G(
  (w, k) => {
    var E, R, j, B, H, M;
    const { questions: o, question: e, onChange: u, disabled: s = !1, language: I, autoFocus: b = !1, bold: P = !1, getTranslation: d, namePrefix: g, errors: r, errorKeyPrefix: $ = "" } = w, m = $ + e.id, c = (t) => {
      if (!s) {
        const n = {
          ...e,
          answer: t,
          answeredAt: Date.now()
        };
        u(n);
      }
    };
    let i = null;
    switch (e.type) {
      case l.Text: {
        i = /* @__PURE__ */ a(
          ue,
          {
            value: e.answer || "",
            onChange: c,
            disabled: s,
            props: { autoFocus: b },
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.FreeText: {
        i = /* @__PURE__ */ a(
          z,
          {
            value: e.answer || "",
            onChange: c,
            disabled: s,
            props: { autoFocus: b },
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.YesNo: {
        const t = (n) => {
          c(n === "yes");
        };
        i = /* @__PURE__ */ a(
          J,
          {
            value: e.answer === void 0 || e.answer === null ? void 0 : e.answer ? "yes" : "no",
            onChange: t,
            disabled: s,
            getTranslation: d,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Scale: {
        i = /* @__PURE__ */ a(
          se,
          {
            value: e.answer,
            labels: e.labels,
            min: e.lowerBound,
            max: e.upperBound,
            onChange: c,
            disabled: s
          }
        );
        break;
      }
      case l.Financial:
      case l.Numeric: {
        i = /* @__PURE__ */ a(
          U,
          {
            value: e.answer,
            onChange: c,
            disabled: s,
            props: { autoFocus: b },
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Time: {
        i = /* @__PURE__ */ a(
          te,
          {
            value: e.answer,
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Date: {
        i = /* @__PURE__ */ a(
          Z,
          {
            value: e.answer,
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.SplitDate: {
        i = /* @__PURE__ */ a(
          oe,
          {
            value: e.answer,
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.File: {
        i = /* @__PURE__ */ a(
          le,
          {
            value: e.answer,
            onChange: c,
            disabled: s,
            language: I,
            getTranslation: d
          }
        );
        break;
      }
      case l.DateTime: {
        i = /* @__PURE__ */ a(
          ee,
          {
            value: e.answer || Date.now(),
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Radio: {
        i = /* @__PURE__ */ a(ae, { children: (E = e == null ? void 0 : e.options) == null ? void 0 : E.map((t, n) => {
          var f;
          return /* @__PURE__ */ W(_, { children: [
            /* @__PURE__ */ a(
              ne,
              {
                checked: e.answer === t.value,
                value: t.value,
                label: v(t.label, o),
                name: g ? `${g}-${e.id}` : e.id,
                onChange: c,
                disabled: s,
                error: !!(r && r[m])
              }
            ),
            e.answer === t.value && t.description ? /* @__PURE__ */ a(
              A,
              {
                text: v(t.description, o)
              }
            ) : null,
            e.answer === t.value && t.questions ? (f = t.questions) == null ? void 0 : f.map((p, h) => /* @__PURE__ */ a(
              F,
              {
                questions: o,
                question: p,
                getTranslation: d,
                onChange: (N) => {
                  var D;
                  const y = { ...e };
                  y.options = (D = y.options) == null ? void 0 : D.map((T) => {
                    var Q;
                    const C = { ...T };
                    return C.value === t.value && (C.questions = (Q = C.questions) == null ? void 0 : Q.map((x) => x.id === N.id ? N : x)), C;
                  }), u({
                    ...y,
                    answeredAt: Date.now()
                  });
                },
                disabled: s,
                language: I,
                props: {
                  style: { paddingLeft: "20px" },
                  className: q.childQuestionWrapper
                },
                errors: r
              },
              h
            )) : null
          ] }, n);
        }) });
        break;
      }
      case l.Dropdown: {
        i = /* @__PURE__ */ a(
          fe,
          {
            value: e.answer,
            options: ((R = e == null ? void 0 : e.options) == null ? void 0 : R.map((t) => ({ label: t.label, value: t.value }))) || [],
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Checkbox: {
        const t = (n, f) => {
          const p = [...e.answer || []];
          if (f)
            p.push(n);
          else {
            const h = p.indexOf(n);
            h !== -1 && p.splice(h, 1);
          }
          c(p);
        };
        i = /* @__PURE__ */ a(S, { children: (j = e == null ? void 0 : e.options) == null ? void 0 : j.map((n) => {
          var f, p, h;
          return /* @__PURE__ */ W(_, { children: [
            /* @__PURE__ */ a(
              X,
              {
                checked: (f = e.answer) == null ? void 0 : f.includes(n.value),
                value: n.value,
                label: v(n.label, o),
                onChange: t,
                disabled: s,
                error: !!(r && r[m])
              },
              n.value
            ),
            (p = e.answer) != null && p.includes(n.value) ? /* @__PURE__ */ W(S, { children: [
              n.description ? /* @__PURE__ */ a(
                A,
                {
                  text: v(
                    n.description,
                    o
                  )
                }
              ) : null,
              (h = n.questions) != null && h.length ? /* @__PURE__ */ a(S, { children: n.questions.map((N, y) => /* @__PURE__ */ a(
                F,
                {
                  questions: o,
                  question: N,
                  getTranslation: d,
                  onChange: (D) => {
                    var C;
                    const T = { ...e };
                    T.options = (C = T.options) == null ? void 0 : C.map(
                      (Q) => {
                        var Y;
                        const x = { ...Q };
                        return x.value === n.value && (x.questions = (Y = x.questions) == null ? void 0 : Y.map((K) => K.id === D.id ? D : K)), x;
                      }
                    ), u({
                      ...T,
                      answeredAt: Date.now()
                    });
                  },
                  disabled: s,
                  language: I,
                  props: {
                    style: { paddingLeft: "20px" },
                    className: q.childQuestionWrapper
                  },
                  errors: r
                },
                y
              )) }) : null
            ] }) : null
          ] }, n.value);
        }) });
        break;
      }
      case l.Items: {
        i = /* @__PURE__ */ a(
          V,
          {
            questions: o,
            question: e,
            onChange: u,
            disabled: s,
            language: I,
            getTranslation: d,
            errors: r
          }
        );
        break;
      }
      case l.MultiPart: {
        const t = (n) => (f) => {
          const p = { ...e, questions: [...e.questions] };
          p.questions[n] = { ...f, answeredAt: Date.now() }, u(p);
        };
        i = /* @__PURE__ */ a("div", { className: q.multiPartQuestion, children: (B = e == null ? void 0 : e.questions) == null ? void 0 : B.map((n, f) => {
          if (n.onlyAvailableIf) {
            const p = n.onlyAvailableIf, h = L(
              p.questionId,
              o
            );
            if (h && h.answer !== (p == null ? void 0 : p.answer))
              return null;
          }
          return /* @__PURE__ */ a(
            F,
            {
              questions: o,
              question: n,
              onChange: t(f),
              disabled: s,
              getTranslation: d,
              language: I,
              props: {
                className: q.childQuestionWrapper
              },
              errors: r,
              errorKeyPrefix: $
            },
            f
          );
        }) });
        break;
      }
      case l.Email: {
        i = /* @__PURE__ */ a(
          ie,
          {
            value: e.answer || "",
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Phone: {
        i = /* @__PURE__ */ a(
          pe,
          {
            value: e.answer || "",
            onChange: c,
            disabled: s,
            error: !!(r && r[m])
          }
        );
        break;
      }
      case l.Select: {
        i = /* @__PURE__ */ a(ce, { value: e.answer, onChange: c, disabled: s, error: !!(r && r[e.id]), children: (H = e == null ? void 0 : e.options) == null ? void 0 : H.map((t) => /* @__PURE__ */ a("option", { value: t.value, children: v(t.label, o) }, t.value)) });
        break;
      }
    }
    return /* @__PURE__ */ O(
      "div",
      {
        ref: k,
        ...w.props,
        className: `${q.questionWrapper} ${((M = w.props) == null ? void 0 : M.className) ?? ""}`,
        key: e.id
      },
      e.question && (e.question || "").trim().length > 0 ? /* @__PURE__ */ a(
        re,
        {
          text: v(e.question, o),
          tooltip: /* @__PURE__ */ a(me, { title: e.question, text: e.tooltip }),
          bold: P,
          getTranslation: d
        }
      ) : null,
      e.description ? /* @__PURE__ */ a(
        A,
        {
          text: /* @__PURE__ */ a(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: v(e.description, o)
              }
            }
          )
        }
      ) : null,
      i,
      e.information ? /* @__PURE__ */ a(
        A,
        {
          text: v(e.information, o)
        }
      ) : null,
      r && r[m] ? /* @__PURE__ */ a(de, { text: r[m] }) : null
    );
  }
);
F.displayName = "QuestionWrapper";
export {
  F as QuestionWrapper
};
